import React, { Component } from "react";
import * as echarts from "echarts/dist/echarts.js";
import "bootstrap/dist/css/bootstrap.css";
import "./dashboard.css";

class ChartHeater extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
    this.timerID = null;

    this.state = {
      thisHumanTime: [],
    };

    // Colors must match LineGraph
    this.colors = {
      avgRth: "red",
     /*  returnT: "orange",
      supplyT: "DodgerBlue",
      outsideT: "magenta",
      roomT: "green",
      setT: "red", */
    };
  }

  componentDidMount() {
    this.chart = echarts.init(document.getElementById("thermostat-chart"));
    this.updateChartFromProps();
    console.log("this props for heater:", this.props);

    // this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentDidUpdate(prevProps) {
 /*    if (
      prevProps.dataDate !== this.props.dataDate ||
      prevProps.timeZone !== this.props.timeZone ||
      prevProps.maxTemp !== this.props.maxTemp ||
      prevProps.minTemp !== this.props.minTemp
    ) {
      this.updateChartFromProps();
    }

    if (
      prevProps.avgReturnT !== this.props.avgReturnT ||
      prevProps.avgSupplyT !== this.props.avgSupplyT ||
      prevProps.avgOutsideT !== this.props.avgOutsideT ||
      prevProps.avgRoomT !== this.props.avgRoomT ||
      prevProps.avgSetT !== this.props.avgSetT
    ) {
      this.updateSeriesData();
    }
   */

  }

  componentWillUnmount() {
    clearInterval(this.timerID);
    if (this.chart) this.chart.dispose();
  }

  hasData() {
    const { dataDate,avgRth, avgReturnT, avgSupplyT, avgOutsideT, avgRoomT, avgSetT } =
      this.props;

    if (!Array.isArray(dataDate) || dataDate.length === 0) return false;

    const seriesArrays = [
     /*  avgReturnT,
      avgSupplyT,
      avgOutsideT,
      avgRoomT,
      avgSetT, */
      avgRth,
    ];

    return seriesArrays.some((arr) => Array.isArray(arr) && arr.length > 0);
  }

  showNoData(message = "No data to show") {
    if (!this.chart) return;

    this.chart.clear();

    this.chart.setOption({
      graphic: [
        {
          type: "text",
          left: "center",
          top: "middle",
          z: 100,
          style: {
            text: message,
            fontSize: 16,
            fontWeight: "bold",
            fill: "#999",
          },
        },
      ],
      series: [], // important: remove stale lines
    });
  }

  hideNoData() {
    if (!this.chart) return;
    this.chart.setOption({ graphic: [] });
  }

  //----------------------------------------------------------
  //       FULL UPDATE (rebuild X-axis + full option)
  //----------------------------------------------------------
  updateChartFromProps() {
    if (!this.chart) return;

    if (!this.hasData()) {
      this.showNoData("No data available for selected time range");
      return;
    }

    this.hideNoData();
    const dataDate = Array.isArray(this.props.dataDate)
      ? this.props.dataDate
      : [];

    const thisHumanTime = dataDate.map((ts) => {
      const d = new Date(ts * 1000);
      const date = `${
        d.getUTCMonth() + 1
      }/${d.getUTCDate()}/${d.getUTCFullYear()}`;
      const hh = String(d.getUTCHours()).padStart(2, "0");
      const mm = String(d.getUTCMinutes()).padStart(2, "0");
      return `${date} @ ${hh}:${mm}`;
    });

    this.setState({ thisHumanTime }, () => {
      const option = {
        // -------- MATCH LineGraph --------
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            animation: false,
            label: { backgroundColor: "#6a7985", precision: "2" },
          },
          hideDelay: 800,
        },

        legend: {
          type: "scroll",
          data: [
            "Return T (F)",
            "Supply T (F)",
            "Outside T (F)",
            "Room T (F)",
            "Set T (F)",
          ],
          center: "50%",
          top: "0%",
          orient: "horizontal",
          padding: 3,
          textStyle: {
            fontSize: 10,
            fontWeight: "bold",
            color: "grey",
          },
          backgroundColor: "transparent",
          borderColor: "#ffffff",
          borderWidth: 1,
          borderRadius: 0,
        },

        xAxis: [
          {
            type: "category",
            data: this.state.thisHumanTime,
            axisTick: { show: true },
            splitLine: { show: true },
            axisLabel: {
              fontSize: 8,
              color: "orange",
            },
            boundaryGap: false,
          },
        ],

        // yAxis: [
        //   {
        //     show: false, // HIDE y-axis (matches LineGraph)
        //     type: "value",
        //     max: this.props.maxTemp + 5,
        //     min: this.props.minTemp - 5,
        //     splitLine: { show: true },
        //   },
        // ],
        yAxis: [
          {
            show: true, //true,
            // name: "Power (Watts)",
            // nameLocation: "end",
            // boundaryGap: [0, "10%"],
            type: "value",
            // nameTextStyle: {
            //   fontStyle: "normal",
            //   fontSize: 16,
            //   fontWeight: "bolder",
            //   color: "green",
            // },
            axisLabel: {
              fontStyle: "normal",
              fontSize: 8,
              fontWeight: "normal",
              color: "orange",
            },
          },
          {
            show: false, //true,
            name: "Priority Level",
            position: "right",
            nameLocation: "end",
            splitLine: {
              show: false,
            },
            //boundaryGap: [0, "10%"],
            type: "value",
            nameTextStyle: {
              fontStyle: "normal",
              fontSize: 16,
              fontWeight: "bolder",
              color: "orange",
            },
            axisLabel: {
              fontStyle: "normal",
              fontSize: 10,
              fontWeight: "bold",
              color: "orange",
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            start: 1,
            end: 100,
            height: 20,
          },
          { type: "inside", xAxisIndex: [0], start: 1, end: 100 },
          {
            type: "inside",
            yAxisIndex: 0,
            filterMode: "none",
          },
          {
            type: "slider",
            yAxisIndex: 0,
            right: "8%",
            width: 20,
          },
        ],

        series: [
          {
            name: "avgRth",
            type: "line",
            symbol: "none",
            smooth: 0.25,
            color: "orange",
            data: this.props.avgRth,
          },
         /*  {
            name: "Supply T (F)",
            type: "line",
            symbol: "none",
            smooth: 0.25,
            color: "dodgerBlue",
            data: this.props.avgSupplyT,
          },
          {
            name: "Outside T (F)",
            type: "line",
            symbol: "none",
            smooth: 0.25,
            color: "green",
            data: this.props.avgOutsideT,
          },
          {
            name: "Room T (F)",
            type: "line",
            symbol: "none",
            smooth: 0.25,
            color: "red",
            data: this.props.avgRoomT,
          },
          {
            name: "Set T (F)",
            type: "line",
            symbol: "none",
            smooth: 0.25,
            color: "magenta",
            data: this.props.avgSetT,
          }, */
          /* {
            name: "onTime",
            type: "line",
            step: "middle",
            yAxisIndex: 1,
            symbol: "none",
            color: "none",
            areaStyle: {
              normal: {
                color: "grey",
                opacity: "0.25",
              },
            },
            label: {
              show: true,
              position: "top",
            },
            data: this.props.onTime,
          },  */
          {
          name: "offTime",
          type: "line",
          step: "middle",
          yAxisIndex: 1,
          symbol: "none",
          lineStyle: {
            opacity: 0
          },
          areaStyle: {
            color: "rgba(128,128,128,0.25)"
          },
          data: this.props.onTime.map(v => v === 1 ? 0 : 1)
        }
        ],
      };

      this.chart && this.chart.setOption(option, true);
    });
  }

  //----------------------------------------------------------
  //       PARTIAL UPDATE (series only)
  //----------------------------------------------------------
  updateSeriesData() {
    if (!this.chart) return;

    const option = this.chart.getOption();
    if (!option.xAxis || option.xAxis.length === 0) {
      return;
    }

    if (!this.state.thisHumanTime || this.state.thisHumanTime.length === 0) {
      return;
    }

    this.chart.setOption({
      yAxis: [
        {
          show: false,
          max: this.props.maxTemp + 5,
          min: this.props.minTemp - 5,
          // splitLine: { show: true },
        },
      ],

      series: [
        {
          name: "Return T (F)",
          type: "line",
          symbol: "none",
          smooth: 0.25,
          color: this.colors.returnT,
          data: this.props.avgReturnT,
        },
        {
          name: "Supply T (F)",
          type: "line",
          symbol: "none",
          smooth: 0.25,
          color: this.colors.supplyT,
          data: this.props.avgSupplyT,
        },
        {
          name: "Outside T (F)",
          type: "line",
          symbol: "none",
          smooth: 0.25,
          color: this.colors.outsideT,
          data: this.props.avgOutsideT,
        },
        {
          name: "Room T (F)",
          type: "line",
          symbol: "none",
          smooth: 0.25,
          color: this.colors.roomT,
          data: this.props.avgRoomT,
        },
        {
          name: "Set T (F)",
          type: "line",
          symbol: "none",
          smooth: 0.25,
          color: this.colors.setT,
          data: this.props.avgSetT,
        },
      ],
    });
  }

  //----------------------------------------------------------
  //       LIVE TICK (just refresh)
  //----------------------------------------------------------
  tick() {
    if (!this.chart) return;

    this.chart.setOption({
      xAxis: [
        {
          data: this.state.thisHumanTime,
          axisTick: { show: true },
          splitLine: { show: true },
        },
      ],
    });
  }

  render() {
    return (
      <div
        id="thermostat-chart"
        // style={{ width: "100%", height: "350px" }}
      />
    );
  }
}

export default ChartHeater;
